/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { PersonAttachmentDetailViewModel } from "../types/PersonAttachmentDetailViewModel.ts";
import { eAnalysisStatusSchema } from "./eAnalysisStatusSchema.ts";
import { eDocumentationStatusSchema } from "./eDocumentationStatusSchema.ts";

export const personAttachmentDetailViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do anexo da pessoa.")),
  personId: z.optional(
    z.number().int().describe("ID da pessoa à qual o anexo pertence."),
  ),
  fileName: z.string().describe("Nome do arquivo anexado.").nullish(),
  description: z.string().describe("Descrição do anexo.").nullish(),
  documentTypeName: z
    .string()
    .describe("Nome do tipo de documento do anexo.")
    .nullish(),
  enrollmentDocumentId: z
    .number()
    .int()
    .describe("ID do documento de matrícula associado ao anexo. Opcional.")
    .nullish(),
  documentationStatus: z.optional(
    z
      .lazy(() => eDocumentationStatusSchema)
      .describe(
        "0 = Pending | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
      ),
  ),
  statusName: z
    .string()
    .describe("Nome legível do status de documentação do anexo.")
    .nullish(),
  reasonName: z
    .string()
    .describe(
      "Nome do motivo associado ao status do anexo (ex: motivo de rejeição). Opcional.",
    )
    .nullish(),
  documentRejectionId: z
    .number()
    .int()
    .describe("ID do motivo de rejeição do documento. Opcional.")
    .nullish(),
  documentationApproveDate: z
    .string()
    .datetime()
    .describe("Data de aprovação da documentação. Opcional.")
    .nullish(),
  documentationApprovePersonId: z
    .number()
    .int()
    .describe(
      "ID da pessoa responsável pela aprovação da documentação. Opcional.",
    )
    .nullish(),
  documentationRejectDate: z
    .string()
    .datetime()
    .describe("Data de rejeição da documentação. Opcional.")
    .nullish(),
  documentationRejectPersonId: z
    .number()
    .int()
    .describe(
      "ID da pessoa responsável pela rejeição da documentação. Opcional.",
    )
    .nullish(),
  analysisStatus: z.optional(
    z
      .lazy(() => eAnalysisStatusSchema)
      .describe(
        "0 = Recognized | 1 = NotRecognized | 2 = SentToAnalysis | 3 = NotAnalyzed | ",
      ),
  ),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação do anexo. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração do anexo. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o anexo está ativo.")),
}) as unknown as ToZod<PersonAttachmentDetailViewModel>;
